<template>
	<footer id="site-footer" class="in-module" role="contentinfo" itemscope="itemscope" itemtype="http://schema.org/WPFooter">
    <a href="#app" class="pagetop"><span>▲ ページの先頭へ</span></a>
    <div class="max">
      <div class="company">
        <figure><img src="/images/common/logo_w.webp" alt="若松本店"></figure>
        <p>〒286-0026 千葉県成田市本町355<br>TEL.0476-22-1136 / FAX.0476-24-1347</p>
      </div>
      <nav>
        <ul id="fnav">
          <li itemprop="name"><a itemprop="url" href="/top/">HOME</a></li>
          <li itemprop="name"><a itemprop="url" href="/rooms/">お部屋</a></li>
          <li itemprop="name"><a itemprop="url" href="/dishes/">お料理</a></li>
          <li itemprop="name"><a itemprop="url" href="/facilities/">館内施設</a></li>
          <li itemprop="name"><a itemprop="url" href="/access/">アクセス</a></li>
          <li itemprop="name"><a itemprop="url" href="/access/#sec_c">周辺観光</a></li>
          <li itemprop="name"><a itemprop="url" target="_blank" rel="nofollow" href="https://www.jhpds.net/wakamatsuhonten/uw/uwp3100/uww3101.do?yadNo=339445" class="externalLink">宿泊プラン</a></li>
          <li itemprop="name"><a itemprop="url" href="/news/">新着情報</a></li>
          <li itemprop="name"><a itemprop="url" href="/plan/">日帰りプラン</a></li>
          <li itemprop="name"><a itemprop="url" href="/faq/">よくあるお問い合せ</a></li>
          <li itemprop="name"><a itemprop="url" target="_blank" rel="nofollow" href="https://www.jhpds.net/wakamatsuhonten/uw/uwp3100/uww3101.do?yadNo=339445">ご予約</a></li>
        </ul>
      </nav>
    </div>
    <small class="copy">Copyright &copy; {{ currentYear }} wakamatsuhonten All rights reserved.</small>
	</footer>
</template>

<style lang="scss" scoped>
footer{
  @include module.texture(-2);
  color: module.$border;
  position: relative;
  z-index: 10;
  a{
    color: module.$border;
  }
  .pagetop{
    border-bottom: rgba(module.$white,.04) 1px solid;
    display: block;
    text-align: center;
    padding: 1rem 0;
    position: relative;
    &:before{
      content: '';
      width: 100%;
      height: 2.4rem;
      @include module.texture(-2);
      position: absolute;
      top: 0;
      left: 0;
      transform: translateY(-100%);
      clip-path: polygon(50% 0, 100% 100%, 0 100%);
    }
    span{
      display: block;
      transform: translateY(-1rem);
    }
  }
  .max{
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: module.side2x();
    padding: 4rem module.side();
    @media screen and (max-width: module.$tab){
      grid-template-columns: 1fr;
    }
  }
  .company{
    display: grid;
    grid-gap: 2rem;
    @media screen and (max-width: module.$tab){
      justify-self: center;
    }
    @media screen and (max-width: module.$phone){
      text-align: center;
    }
    figure{
      width: 14.4rem;
      @media screen and (max-width: module.$phone){
        margin: 0 auto;
      }
      img{
        opacity: .8;
        width: 100%;
        object-fit: cover;
      }
    }
    dl{
      line-height: 1.56;
      dt{
        font-size: 1.16rem;
      }
      dd{
        font-size: .88rem;
        margin: .4rem 0 0;
        @media screen and (max-width: module.$phone){
          font-size: .92rem;
        }
      }
    }
  }
  nav{
    ul{
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      grid-column-gap: 1rem;
      grid-row-gap: .4rem;
      @media screen and (max-width: module.$tab){
        grid-template-columns: repeat(4, 1fr);
      }
      @media screen and (max-width: module.$phone){
        grid-template-columns: repeat(2, 1fr);
        gap: 1px;
        text-align: center;
      }
      li{
        @media screen and (max-width: module.$phone){
          &:first-of-type{
            display: none;
          }
        }
        a{
          font-size: .92rem;
          @media screen and (max-width: module.$phone){
            background: lighten(module.$normal, 4%);
            display: block;
            padding: 1.2rem module.side();
          }
          &:hover{
            text-decoration: underline;
            @media screen and (max-width: module.$phone){
              text-decoration: none;
              background: lighten(module.$normal, 6%);
            }
          }
        }
      }
    }
  }
  small{
    display: block;
    text-align: center;
    font-size: .72rem;
    border-top: rgba(module.$white,.04) .1rem solid;
    padding: 1.6rem 0;
  }
}
</style>

<script>
export default {
	data() {
		return {
			currentYear: new Date().getFullYear()
		}
	}
}
</script>